export const eligibleRowStyles = {
  backgroundColor: ({ palette }) => palette.success.light,
};

export const deletedTextStyles = {
  color: ({ palette }) => palette.error.main,
};

export const cellValueWrapperStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  minWidth: 0,
};

export const cellValueTextStyles = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  minWidth: 0,
};

export const cellValueIconStyles = {
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
};
